import { render, staticRenderFns } from "./Marcom.vue?vue&type=template&id=67ae0060&scoped=true&"
import script from "./Marcom.vue?vue&type=script&lang=js&"
export * from "./Marcom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae0060",
  null
  
)

export default component.exports